export default __webpack_public_path__ + "static/media/plus-simulator.0c34e595.png";